// extracted by mini-css-extract-plugin
export var Login = "footer-module--Login--b6b5a";
export var cc = "footer-module--cc--26ee7";
export var container = "footer-module--container--867a5";
export var footer = "footer-module--footer--c0263";
export var footerColHeader = "footer-module--footerColHeader--2daf2";
export var footerColumn = "footer-module--footerColumn--0f4fb";
export var footerHelix = "footer-module--footerHelix--6c8b4";
export var footerNav = "footer-module--footerNav--ec6be";
export var logoWrap = "footer-module--logoWrap--df675";
export var salesAndSupport = "footer-module--salesAndSupport--8da72";
export var socials = "footer-module--socials--3cdee";